<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="heart-outline tw-h-[24px] tw-w-[24px] tw-shrink-0"
    viewBox="2.2 0.7 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      class="heart-outline__path"
      transform="translate(0 1)"
      d="M24.7009 9.1439C24.7025 9.85813 24.5625 10.5656 24.2889 11.2254C24.0154 11.8851 23.6137 12.4841 23.1072 12.9876L14.7353 21.4833C14.6655 21.5541 14.5823 21.6104 14.4906 21.6488C14.3988 21.6872 14.3004 21.707 14.2009 21.707C14.1015 21.707 14.003 21.6872 13.9113 21.6488C13.8195 21.6104 13.7363 21.5541 13.6665 21.4833L5.29467 12.9876C4.274 11.9682 3.7001 10.5851 3.69922 9.14253C3.69834 7.69996 4.27055 6.31613 5.28998 5.29546C6.30941 4.27479 7.69254 3.70089 9.1351 3.70001C10.5777 3.69913 11.9615 4.27135 12.9822 5.29077L14.2009 6.42984L15.4281 5.28702C16.1898 4.52914 17.1589 4.0139 18.2132 3.80637C19.2674 3.59883 20.3595 3.70829 21.3516 4.12094C22.3437 4.53358 23.1913 5.23091 23.7874 6.12489C24.3835 7.01886 24.7014 8.06941 24.7009 9.1439Z"
      :fill="filled ? '#E7000B' : '#FFFFFF'"
    />
  </svg>
</template>

<script>
export default {
  name: 'HeartOutline',
  props: {
    filled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.heart-outline {
  overflow: visible;
  filter: drop-shadow(0 0 1.85px rgb(0 0 0 / 25%));
}

.heart-outline__path {
  transition: fill 150ms ease;
}

@media (prefers-reduced-motion: reduce) {
  .heart-outline__path {
    transition: none;
  }
}
</style>
